import React, { useCallback } from 'react';

import { CrossAppItemBase, type CrossAppItemBaseProps } from '../CrossAppItemBase';

import { useGicModal } from './GicModalContext';

export function GicIssueCreateItem({
    responseItem,
    context,
    injectClickAnalytics,
}: CrossAppItemBaseProps) {
    const { openGicModal } = useGicModal();

    const handleClick = useCallback(() => {
        openGicModal();
    }, [openGicModal]);

    return (
        <CrossAppItemBase
            responseItem={responseItem}
            context={context}
            customisedItemConfig={{ onClick: handleClick, onClickCloseMenu: true }}
            injectClickAnalytics={injectClickAnalytics}
        />
    )
}